"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationGuardProviderContext = void 0;
const react_1 = __importDefault(require("react"));
exports.NavigationGuardProviderContext = react_1.default.createContext(undefined);
exports.NavigationGuardProviderContext.displayName = "NavigationGuardProviderContext";
